import React from 'react';
import './styles.css'
import { Link } from 'react-router-dom';
import iconFb from './../../images/icon-fb.svg'
import iconLinkedin from './../../images/icon-in.svg'
import iconTwitter from './../../images/icon-tw.svg'

import {
    Container,
    Box,
    Typography,
    Button,
    Stack,
} from "@mui/material";
import Media from 'react-media';


const styles = {
    Container2: {
        background: '#222D45',
        minHeight: '60vh',
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxSizing: 'border-box',
    }
}

 const Footer = () => {

  return (
        <Container style={styles.Container2} maxWidth="100%" >
          <Stack sx={{minWidth: "100%", padding: '2rem'}} direction="column">
            <div className="footer__main">
              <div className="footer__content">
                  <Typography  color="white" variant="h2"sx={{fontFamily: "Abril Fatface"}} >
                      AB Hires</Typography>
                  <Typography  color="white" style={{fontSize: '14px'}}>AB Nurses has been a proud supplier of healthcare
                    professionals to NHS Trusts and agencies across UK and Ireland. We are a team
                    of passionate and driven individuals who have come together to help
                    healthcare professionals get their dream jobs</Typography>
              </div>

                <div className="footer__list" >
                 <Typography color="white" ><Link to="/">HOME</Link></Typography>
                 <Typography color="white" ><Link to="/Services">SERVICES</Link></Typography>
                 <Typography color="white" ><Link to="/Jobs">JOBS</Link></Typography>
                 <Typography color="white" ><Link to="/ContactUs">CONTACT US</Link></Typography>
               </div>

               <div  className="footer__list">
                <Typography color="white" >PRIVACY POLICY</Typography>
                <Typography color="white" >COOKIE SETTINGS</Typography>
                <Typography color="white" ><Link to="/admin">ADMIN LOGIN</Link></Typography>
                <Typography color="white" ><Link to="/Faqs">FAQS</Link></Typography>
              </div>

              <div  className="footer__list">
               <Typography color="white" >REACH US</Typography>
               <Typography color="hsla(212, 98%, 51%, 1)" >+91 9871013411</Typography>
               <Typography color="hsla(212, 98%, 51%, 1)" >info@abnurses.com</Typography>
               <Typography color="hsla(212, 98%, 51%, 1)" >Delhi, India London, UK</Typography>
             </div>


            <div className="footer__list" display="flex" direction="column" gap="2rem" sx={{minWidth: "30%" }}>
              <div className='footer__button--container'>
                <Button sx={{background: '#00509D', color: "#FDC500" , maxHeight: "50px"}}><Link to="/Jobs">Search Job</Link></Button>
                <Button sx={{background: '#00509D', color: "#FDC500", maxHeight: "50px"}}><Link to="/FillVacancy">Fill Vaccancy</Link></Button>
              </div>
              <Stack display="flex" direction="row" justifyContent="flex-start" alignItems="center" gap="2rem">
                <i className="social__icon"><a href="https://www.facebook.com/"><img src={iconFb} alt="facebook"/></a></i>
                <i className="social__icon"><a href="https://www.linkedin.com/"><img src={iconLinkedin} alt="linkedin"/></a></i>
                <i className="social__icon"><a href="https://twitter.com/home"><img src={iconTwitter} alt="twitter"/></a></i>
              </Stack>
            </div >

            </div>
            <Typography color="white" sx={{width: "max-content",
             margin: "1rem auto 2rem", position: "relative", top: "50px"}} >© AB NURSES Ltd</Typography>
            </Stack>
            </Container>
  )
};

export default Footer
